import { Injectable, EventEmitter } from "@angular/core";
import { ActNowDictionaryItem, KeyValueModel } from "@models/common";
import { ShapeColorOptions, AreaMapRequest, AdditionalMapFilter, RaceEthnicityMapFilter, PovertyMapFilter, EducationalAttainmentMapFilter, EmploymentMapFilter, HousingMapFilter } from "@models/map";

@Injectable()
export class MapValuesService {
    public updateMap$: EventEmitter<AreaMapRequest> = new EventEmitter<AreaMapRequest>();
    public areaOptions: ActNowDictionaryItem[] = [
        {
            id: 1,
            text: "Zip Code"
        },
        {
            id: 2,
            text: "City"
        },
        {
            id: 3,
            text: "County"
        },
        {
            id: 4,
            text: "Federal House District"
        },
        {
            id: 5,
            text: "State House District"
        },
        {
            id: 6,
            text: "State Senate District"
        },
        {
            id: 7,
            text: "IDHS Region"
        }
    ];

    public programOptions: ActNowDictionaryItem[] = [
        {
            id: 1,
            text: "Recreation/Team Sports"
        },
        {
            id: 2,
            text: "Homework Assistance"
        },
        {
            id: 3,
            text: "Instructional Support"
        },
        {
            id: 4,
            text: "ProjectBased Enrichment"
        },
        {
            id: 5,
            text: "STEM/STEAM"
        },
        {
            id: 6,
            text: "Reading & Writing"
        },
        {
            id: 7,
            text: "Career & College Preparation"
        },
        {
            id: 8,
            text: "Performing Arts"
        },
        {
            id: 9,
            text: "Health and Wellness"
        },
        {
            id: 10,
            text: "Mentoring"
        },
        {
            id: 11,
            text: "Civic Engagement"
        },
        {
            id: 12,
            text: "Family Engagement"
        },
        {
            id: 13,
            text: "Food Experiences"
        },
        {
            id: 14,
            text: "Multi-Cultural Experiences"
        },
        {
            id: 16,
            text: "Community Schools"
        },
        {
            id: 15,
            text: "Other"
        }
    ];

    public gradeOptions: ActNowDictionaryItem[] = [
        {
            id: 1,
            text: "Pre-K"
        },
        {
            id: 2,
            text: "Kindergarten"
        },
        {
            id: 3,
            text: "1st"
        },
        {
            id: 4,
            text: "2nd"
        },
        {
            id: 5,
            text: "3rd"
        },
        {
            id: 6,
            text: "4th"
        },
        {
            id: 7,
            text: "5th"
        },
        {
            id: 8,
            text: "6th"
        },
        {
            id: 9,
            text: "7th"
        },
        {
            id: 10,
            text: "8th"
        },
        {
            id: 11,
            text: "9th"
        },
        {
            id: 12,
            text: "10th"
        },
        {
            id: 13,
            text: "11th"
        },
        {
            id: 14,
            text: "12th"
        },
        {
            id: 15,
            text: "Out-of-School Youth"
        }
    ];
    private povertyAgeOptions: KeyValueModel[] = [
        {
            value: "1",
            key: "All Ages"
        },
        {
            value: "2",
            key: "Age 0-17"
        },
        {
            value: "3",
            key: "Age 5-17 in Families"
        }
    ];
    private povertyTypeOptions: KeyValueModel[] = [
        {
            value: "1",
            key: "Poverty Estimate"
        },
        {
            value: "2",
            key: "90% CI Lower Bound"
        },
        {
            value: "3",
            key: "90% CI Upper Bound"
        },
        {
            value: "4",
            key: "Poverty Percent by Age"
        },
        {
            value: "5",
            key: "90% CI Lower Bound %"
        },
        {
            value: "6",
            key: "90% CI Upper Bound %"
        }
    ];
    public povertyFilters: AdditionalMapFilter[] = [
        { 
            label: 'Age',
            key: PovertyMapFilter.Age,
            options: this.povertyAgeOptions,
            defaultValue: '1'
        },
        { 
            label: 'Type',
            key: PovertyMapFilter.Type,
            options: this.povertyTypeOptions,
            defaultValue: '1'
        },
    ];

    private raceEthnicityYearOptions: KeyValueModel[] = [        
        {
            value: "2020",
            key: "2020"
        },
        {
            value: "2025",
            key: "2025"
        },
        {
            value: "2030",
            key: "2030"
        },
    ];
    private raceEthnicityRaceOptions: KeyValueModel[] = [
        {
            value: "",
            key: "All"
        },
        {
            value: "Non-Hispanic",
            key: "Non-Hispanic"
        },
        {
            value: "Asian",
            key: "Asian"
        },
        {
            value: "Hispanic",
            key: "Hispanic"
        },
        {
            value: "Black",
            key: "Black"
        },
        {
            value: "White",
            key: "White"
        },
        {
            value: "Other",
            key: "Other"
        },
    ];
    private raceEthnicityAgeOptions: KeyValueModel[] = [
        {
            value: "",
            key: "All"
        },
        {
            value: "0-4",
            key: "0-4"
        },
        {
            value: "5-9",
            key: "5-9"
        },
        {
            value: "10-14",
            key: "10-14"
        },
        {
            value: "15-19",
            key: "15-19"
        },
        {
            value: "20-24",
            key: "20-24"
        },
        {
            value: "25-29",
            key: "25-29"
        },
        {
            value: "30-34",
            key: "30-34"
        },
        {
            value: "35-39",
            key: "35-39"
        },
        {
            value: "40-44",
            key: "40-44"
        },
        {
            value: "45-49",
            key: "45-49"
        },
        {
            value: "50-54",
            key: "50-54"
        },
        {
            value: "55-59",
            key: "55-59"
        },
        {
            value: "60-64",
            key: "60-64"
        },
        {
            value: "65-69",
            key: "65-69"
        },
        {
            value: "70-74",
            key: "70-74"
        },
        {
            value: "75-79",
            key: "75-79"
        },
        {
            value: "80-84",
            key: "80-84"
        },
        {
            value: "85+",
            key: "85+"
        }
    ];
    private raceEthnicitySexOptions: KeyValueModel[] = [
        {
            value: "",
            key: "All"
        },
        {
            value: "M",
            key: "Male"
        },
        {
            value: "F",
            key: "Female"
        },
    ];
    public raceEthnicityFilters: AdditionalMapFilter[] = [
        { 
            label: 'Year',
            key: RaceEthnicityMapFilter.Year,
            options: this.raceEthnicityYearOptions,
            defaultValue: '2020'
        },
        { 
            label: 'Race',
            key: RaceEthnicityMapFilter.Race,
            options: this.raceEthnicityRaceOptions,
            defaultValue: ''
        },
        { 
            label: 'Age',
            key: RaceEthnicityMapFilter.Age,
            options: this.raceEthnicityAgeOptions,
            defaultValue: ''
        },
        { 
            label: 'Sex',
            key: RaceEthnicityMapFilter.Sex,
            options: this.raceEthnicitySexOptions,
            defaultValue: ''
        }
    ];

    private educationalAttainmentYearOptions: KeyValueModel[] = [
        {
            key: '2019',
            value: '2019'
        },
        {
            key: '2018',
            value: '2018'
        },
        {
            key: '2017',
            value: '2017'
        }, 
        {
            key: '2016',
            value: '2016'
        },
        {
            key: '2015',
            value: '2015'
        },
        {
            key: '2014',
            value: '2014'
        },
        {
            key: '2013',
            value: '2013'
        },
        {
            key: '2012',
            value: '2012'
        },
        {
            key: '2011',
            value: '2011'
        },
        {
            key: '2010',
            value: '2010'
        },
        {
            key: '2009',
            value: '2009'
        },
    ];
    public educationalAttainmentFilters: AdditionalMapFilter[] = [
        { 
            label: 'Year',
            key: EducationalAttainmentMapFilter.Year,
            options: this.educationalAttainmentYearOptions,
            defaultValue: '2019'
        }
    ];

    private employmentYearOptions: KeyValueModel[] = [
        {
            key: 'PRELIMINARY AUGUST 2022',
            value: 'PRELIMINARY AUGUST 2022'
        },
        {
            key: 'REVISED JULY 2022',
            value: 'REVISED JULY 2022'
        },
    ];
    private employmentFieldOptions: KeyValueModel[] = [
        {
            key: 'Labor Force',
            value: '1'
        },
        {
            key: 'Unemployed Number',
            value: '2'
        },
        {
            key: 'Unemployed Rate',
            value: '3'
        },
    ];
    public employmentFilters: AdditionalMapFilter[] = [
        { 
            label: 'Period',
            key: EmploymentMapFilter.Year,
            options: this.employmentYearOptions,
            defaultValue: 'PRELIMINARY AUGUST 2022'
        },
        { 
            label: 'Field',
            key: EmploymentMapFilter.Field,
            options: this.employmentFieldOptions,
            defaultValue: '1'
        }
    ];

    private housingFieldOptions: KeyValueModel[] = [
        {
            key: 'Total households (2016-2020)',
            value: 'Total households (2016-2020)',
        },
        {
            key: 'Renter households (2016-2020)',
            value: 'Renter households (2016-2020)',
        },
        {
            key: '% of total households that are renters (2016-2020)',
            value: '% of total households that are renters (2016-2020)',
        },
        {
            key: 'Minimum wage',
            value: 'Minimum wage',
        },
        {
            key: 'Estimated mean renter wage',
            value: 'Estimated mean renter wage',
        },
        {
            key: 'SSI monthly payment',
            value: 'SSI monthly payment',
        },
        {
            key: 'Zero bedroom FMR',
            value: 'Zero bedroom FMR',
        },
        {
            key: 'One bedroom FMR',
            value: 'One bedroom FMR',
        },
        {
            key: 'Two bedroom FMR',
            value: 'Two bedroom FMR',
        },
        {
            key: 'Three bedroom FMR',
            value: 'Three bedroom FMR',
        },
        {
            key: 'Four bedroom FMR',
            value: 'Four bedroom FMR',
        },
        {
            key: 'Annual AMI',
            value: 'Annual AMI',
        },
        {
            key: '30% of AMI',
            value: '30% of AMI',
        },
        {
            key: '50% of AMI',
            value: '50% of AMI',
        },
        {
            key: 'Estimated median renter household income',
            value: 'Estimated median renter household income',
        },
        {
            key: 'Rent affordable at 30% AMI',
            value: 'Rent affordable at 30% AMI',
        },
        {
            key: 'Rent affordable at 50% AMI',
            value: 'Rent affordable at 50% AMI',
        },
        {
            key: 'Rent affordable at median renter household income',
            value: 'Rent affordable at median renter household income',
        },
        {
            key: 'Rent affordable with full-time job paying minimum wage',
            value: 'Rent affordable with full-time job paying minimum wage',
        },
        {
            key: 'Rent affordable with full-time job paying mean renter wage',
            value: 'Rent affordable with full-time job paying mean renter wage',
        },
        {
            key: 'Rent affordable to SSI recipient',
            value: 'Rent affordable to SSI recipient',
        },
        {
            key: 'Income needed to afford 0 bdrm FMR',
            value: 'Income needed to afford 0 bdrm FMR',
        },
        {
            key: 'Income needed to afford 1 bdrm FMR',
            value: 'Income needed to afford 1 bdrm FMR',
        },
        {
            key: 'Income needed to afford 2 bdrm FMR',
            value: 'Income needed to afford 2 bdrm FMR',
        },
        {
            key: 'Income needed to afford 3 bdrm FMR',
            value: 'Income needed to afford 3 bdrm FMR',
        },
        {
            key: 'Income needed to afford 4 bdrm FMR',
            value: 'Income needed to afford 4 bdrm FMR',
        },
        {
            key: 'Housing Wage for 0 bdrm FMR',
            value: 'Housing Wage for 0 bdrm FMR',
        },
        {
            key: 'Housing Wage for 1 bdrm FMR',
            value: 'Housing Wage for 1 bdrm FMR',
        },
        {
            key: 'Housing Wage for 2 bdrm FMR',
            value: 'Housing Wage for 2 bdrm FMR',
        },
        {
            key: 'Housing Wage for 3 bdrm FMR',
            value: 'Housing Wage for 3 bdrm FMR',
        },
        {
            key: 'Housing Wage for 4 bdrm FMR',
            value: 'Housing Wage for 4 bdrm FMR',
        },
        {
            key: 'Work hours per week at min. wage needed to afford 0 bdrm FMR',
            value: 'Work hours per week at min. wage needed to afford 0 bdrm FMR',
        },
        {
            key: 'Work hours per week at min. wage needed to afford 1 bdrm FMR',
            value: 'Work hours per week at min. wage needed to afford 1 bdrm FMR',
        },
        {
            key: 'Work hours per week at min. wage needed to afford 2 bdrm FMR',
            value: 'Work hours per week at min. wage needed to afford 2 bdrm FMR',
        },
        {
            key: 'Work hours per week at min. wage needed to afford 3 bdrm FMR',
            value: 'Work hours per week at min. wage needed to afford 3 bdrm FMR',
        },
        {
            key: 'Work hours per week at min. wage needed to afford 4 bdrm FMR',
            value: 'Work hours per week at min. wage needed to afford 4 bdrm FMR',
        },
        {
            key: '# of jobs at minimum wage needed to afford a 0 bdrm FMR',
            value: '# of jobs at minimum wage needed to afford a 0 bdrm FMR',
        },
        {
            key: '# of jobs at minimum wage needed to afford a 1 bdrm FMR',
            value: '# of jobs at minimum wage needed to afford a 1 bdrm FMR',
        },
        {
            key: '# of jobs at minimum wage needed to afford a 2 bdrm FMR',
            value: '# of jobs at minimum wage needed to afford a 2 bdrm FMR',
        },
        {
            key: '# of jobs at minimum wage needed to afford a 3 bdrm FMR',
            value: '# of jobs at minimum wage needed to afford a 3 bdrm FMR',
        },
        {
            key: '# of jobs at minimum wage needed to afford a 4 bdrm FMR',
            value: '# of jobs at minimum wage needed to afford a 4 bdrm FMR',
        },
        {
            key: 'Work hours per week at mean renter wage needed to afford 0 bdrm FMR',
            value: 'Work hours per week at mean renter wage needed to afford 0 bdrm FMR',
        },
        {
            key: 'Work hours per week at mean renter wage needed to afford 1 bdrm FMR',
            value: 'Work hours per week at mean renter wage needed to afford 1 bdrm FMR',
        },
        {
            key: 'Work hours per week at mean renter wage needed to afford 2 bdrm FMR',
            value: 'Work hours per week at mean renter wage needed to afford 2 bdrm FMR',
        },
        {
            key: 'Work hours per week at mean renter wage needed to afford 3 bdrm FMR',
            value: 'Work hours per week at mean renter wage needed to afford 3 bdrm FMR',
        },
        {
            key: 'Work hours per week at mean renter wage needed to afford 4 bdrm FMR',
            value: 'Work hours per week at mean renter wage needed to afford 4 bdrm FMR',
        },
    ];
    public housingFilters: AdditionalMapFilter[] = [
        { 
            label: 'Field',
            key: HousingMapFilter.Field,
            options: this.housingFieldOptions,
            defaultValue: 'Total households (2016-2020)'
        }
    ]

    public mapCenter: any = { lat: 40.05, lng: -89.18 };
    public stateZoom: number = 7;
    private StateStrokeOpacity: number = .8;
    private StateStrokeWeight: number = 1;
    private StateFillOpacity: number = 0.55;

    public housingShapeStrokeColor = "#9b2283";
    public housingHiShapeColor = "#9b2283";
    public housingMidHiShapeColor = "#bd4ca6";
    public housingMidLoShapeColor = "#dd9fd1";
    public housingLoShapeColor = "#f3dbee";

    public employmentShapeStrokeColor = "#9b9a22";
    public employmentHiShapeColor = "#9b9a22";
    public employmentMidHiShapeColor = "#c3c24f";
    public employmentMidLoShapeColor = "#cfce9b";
    public employmentLoShapeColor = "#f7f7df";

    public educationalAttainmentShapeStrokeColor = "#18781d";
    public educationalAttainmentHiShapeColor = "#18781d";
    public educationalAttainmentMidHiShapeColor = "#399d3f";
    public educationalAttainmentMidLoShapeColor = "#9ed9a2";
    public educationalAttainmentLoShapeColor = "#daf9dc";

    public raceEthnicityShapeStrokeColor = "#70229b";
    public raceEthnicityHiShapeColor = "#70229b";
    public raceEthnicityMidHiShapeColor = "#8e4bb3";
    public raceEthnicityMidLoShapeColor = "#c192db";
    public raceEthnicityLoShapeColor = "#efddf9";
    
    public povertyShapeStrokeColor = "#9b2222";
    public povertyHiShapeColor = "#9b2222";
    public povertyMidHiShapeColor = "#c45050";
    public povertyMidLoShapeColor = "#e0a3a3";
    public povertyLoShapeColor = "#f8dfdf";

    public baseShapeOpts: ShapeColorOptions = {
        strokeColor: "#C9C9C9",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "#C9C9C9",
        fillOpacity: 0.35
    };

    public hiShapeOpts: ShapeColorOptions = {
        strokeColor: "#224e9b",
        strokeOpacity: this.StateStrokeOpacity,
        strokeWeight: this.StateStrokeWeight,
        fillColor: "#224e9b",
        fillOpacity: this.StateFillOpacity
    };

    public midHiShapeOpts: ShapeColorOptions = {
        strokeColor: "#224e9b",
        strokeOpacity: this.StateStrokeOpacity,
        strokeWeight: this.StateStrokeWeight,
        fillColor: "#5090c4",
        fillOpacity: this.StateFillOpacity,
    };

    public midLoShapeOpts: ShapeColorOptions = {
        strokeColor: "#224e9b",
        strokeOpacity: this.StateStrokeOpacity,
        strokeWeight: this.StateStrokeWeight,
        fillColor: "#a3c9e0",
        fillOpacity: this.StateFillOpacity
    };

    public loShapeOpts: ShapeColorOptions = {
        strokeColor: "#224e9b",
        strokeOpacity: this.StateStrokeOpacity,
        strokeWeight: this.StateStrokeWeight,
        fillColor: "#dfecf8",
        fillOpacity: this.StateFillOpacity
    };

    public zoomShapeOpts: ShapeColorOptions = {
        strokeColor: "#224e9b",
        strokeOpacity: this.StateStrokeOpacity,
        strokeWeight: 2,
        fillColor: undefined,
        fillOpacity: 0
    };

    public triggerMapUpdate(search: AreaMapRequest) {
        this.updateMap$.next(search);
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/map/map-values.service.ts